import {
  useNotificationsQuery,
  Notification,
} from "@/features/workspace/graphql/generated";

const useNotifications = () => {
  const { data, loading, error } = useNotificationsQuery();

  const notifications = (data?.notifications || []) as Notification[];

  const notificationCount = notifications.length;

  return { notifications, notificationCount, loading };
};

export default useNotifications;
